// import {useState, useEffect, useRef} from "react";
// import SectionTitle from "../SectionTitles/SectionTitle";
import SectionTitleTwo from "../SectionTitles/SectionTitleTwo";
// import Tilt from 'react-parallax-tilt';
// import Parallax from 'parallax-js';
// import {Link} from "react-router-dom";

const HomeAbout = () => {
  // const [scale] = useState(1.04);
  // const sceneEl = useRef(null);

  // useEffect(() => {
  //     const parallaxInstance = new Parallax(sceneEl.current, {
  //     relativeInput: true,
  //     })

  //     parallaxInstance.enable();

  //     return () => parallaxInstance.disable();

  // }, [])
  return (
    <div className="section section-padding-t90 section-padding-t50-b0">
      <div className="container">
        {/* <SectionTitle title="Introduction" /> */}

        <div className="row">
          {/* <div className="col-xl-7 col-lg-6 col-12" data-aos="fade-up">
                        <div className="about-image-area">
                            <div className="about-image">
                                <Tilt scale={scale} transitionSpeed={4000}>
                                    <img src={process.env.PUBLIC_URL + "images/about/home-one-about/home_agency_about_1.jpg"} alt="" />
                                </Tilt>
                            </div>
                        
                            <div className="about-image">
                                <Tilt scale={scale} transitionSpeed={4000}>
                                    <img src={process.env.PUBLIC_URL + "images/about/home-one-about/home_agency_about_2.jpg"} alt="" />
                                </Tilt>
                            </div>
                            <div className="shape shape-1" id="scene" ref={sceneEl}>
                                <span data-depth="1"><img src={process.env.PUBLIC_URL + "images/shape-animation/about-shape-1.png"} alt="" /></span>
                            </div>

                        </div>
                    </div> */}

          <div
            className="col-xl-6 col-lg-6 col-12"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div className="about-content-area">
              <SectionTitleTwo
                // subTitle="Every day brings new challenges"
                title="Overview of Data Mining and Big Data (DMBD)"
              />
              <div className="intro">
                <p className="home-p text-justify">
                The Eleventh International Conference on Data Mining and Big Data (DMBD&apos;2026) serves as a global platform for researchers and practitioners to exchange the latest advancements in theories, 
                algorithms, models, and applications of data mining, big data, and artificial intelligence techniques. Data mining involves exploring large datasets to extract meaningful information, 
                while big data encompasses vast amounts of data and information that warrant in-depth research. DMBD&apos;2026 is co-hosted by the State Key Laboratory of General Artificial Intelligence and the International Association of Swarm and Evolutionary Intelligence (IASEI).
                </p>
                <br></br>
                <p className="home-p text-justify">

                  DMBD&apos;2026 marks the eleventh event following successful conferences in Guangzhou, Belgrade, Chiang Mai, Shanghai, Fukuoka, Bali, Sanya, Ho Chi Minh City and Beijing, attracting hundreds of delegates worldwide to share their latest achievements, innovative 
                  ideas, remarkable designs, and excellent implementations. DMBD&apos;2026 will be held in December 2026 in Jeju Island, South Korea.
                </p>
              <br></br>
                {/* <p className="home-p text-justify">
                  This year&apos;s main theme is <strong>FinTech</strong>, and we will pay special attention to technologies
                  and applications in
                  the
                  area of FinTech.
                </p> */}
                <p className="home-p text-justify">
                Jeju Island, the southern volcanic island of South Korea, is renowned for its spectacular volcanic natural landscapes, as well as its distinctive coastal folk culture.
                As an isle that perfectly unites primitive volcanic geology with laid-back coastal charm, Jeju Island is home to iconic landmarks such as 
                </p>
                <br></br>
              </div>

              {/* <Link className="btn btn-primary btn-hover-secondary mt-xl-8 mt-lg-8 mt-md-6 mt-4" to={process.env.PUBLIC_URL + "/about"}>Learn More</Link> */}
            </div>
          </div>

          <div
            className="col-xl-6 col-lg-6 col-12"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div className="about-content-area">
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>

              <p className="home-p text-justify">       
              Mount Hallasan, Seongsan Ilchulbong Peak, and Manjanggul Lava Tube. The island also boasts serene citrus orchards, distinctive volcanic cliff landscapes, and a diverse seafood culinary experience that reflects its volcanic geography and maritime culture.
In December, Jeju’s mild winter charm is enhanced by snow-capped mountain vistas and blooming camellias, offering a tranquil and picturesque backdrop for the conference.   
              </p>
        <br></br>
              <p className="home-p text-justify">
                Papers presented at DMBD&apos;2026 will be published Springer-Nature in Communications in Computer and
                Information Science (CCIS) (indexed by EI, ISTP, DBLP, SCOPUS, ISI, Web of Science, etc.) The downloads
                of our meeting&apos;s proceedings reach the top 25% of all publications of Springer-Nature. Some high-quality
                papers will be selected for SCI-indexed Transaction (including IEEE Trans, Swarm and Evolutionary
                Optimization, etc.) and Journal Special Issues, such as:
                <ul className="home-p">
                  <li>
                    International Journal of Intelligence System (IF=8.71)
                  </li>
                  <li>
                    Electronics (IF=2.690)
                  </li>
                  <li>
                    Multimedia Tools and applications (IF=2.58)
                  </li>
                  <li>
                    Machine Learning with Applications (IF=8.67)
                  </li>
                  <li>
                    IASEI Transactions on Swarm Intelligence
                  </li>
                  <li>
                    ...
                  </li>
                </ul>
              </p>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeAbout;
